// ParentCreate.js
import React, { useState } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  email,
} from 'react-admin';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { supabaseClient } from './supabase';

const ParentCreate = (props) => {
  const [addToExisting, setAddToExisting] = useState(false);
  const [householdError, setHouseholdError] = useState(null);
  const [validatedHash, setValidatedHash] = useState(null);

  const validateHouseholdHash = async (value) => {
    if (!addToExisting) return undefined;
    if (!value) return 'Household hash is required when adding to existing household';

    // Check if this household_hash exists in the parents table
    const { data, error } = await supabaseClient
      .from('parents')
      .select('id, first_name, last_name')
      .eq('household_hash', value)
      .limit(1);

    if (error) {
      setHouseholdError('Error validating household');
      setValidatedHash(null);
      return 'Error validating household';
    }

    if (!data || data.length === 0) {
      setHouseholdError('No household found with this hash');
      setValidatedHash(null);
      return 'No household found with this hash';
    }

    // Valid household found
    setHouseholdError(null);
    setValidatedHash(value);
    return undefined;
  };

  const transform = (data) => {
    // If not adding to existing household, generate a new household_hash (UUID)
    if (!addToExisting || !data.household_hash) {
      data.household_hash = crypto.randomUUID();
    }
    return data;
  };

  return (
    <Create {...props} title="Create Parent" transform={transform}>
      <SimpleForm>
        <TextInput source="first_name" validate={required()} />
        <TextInput source="last_name" validate={required()} />
        <TextInput source="email" validate={[required(), email()]} />
        <TextInput source="mobile" />

        <Box sx={{ mt: 2, mb: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={addToExisting}
                onChange={(e) => {
                  setAddToExisting(e.target.checked);
                  if (!e.target.checked) {
                    setHouseholdError(null);
                    setValidatedHash(null);
                  }
                }}
                color="primary"
              />
            }
            label="Voeg by bestaande huishouding"
          />
          <Typography variant="caption" display="block" color="text.secondary">
            Merk hierdie opsie as die ouer by 'n bestaande huishouding gevoeg moet word.
            Kopieer die household_hash van enige ouer in daardie huishouding.
          </Typography>
        </Box>

        {addToExisting && (
          <Box sx={{ mt: 1 }}>
            <TextInput
              source="household_hash"
              label="Household Hash"
              validate={validateHouseholdHash}
              helperText={
                validatedHash
                  ? 'Geldige huishouding gevind'
                  : 'Plak die household_hash van \'n bestaande ouer in hierdie huishouding'
              }
              sx={{ width: 400 }}
              FormHelperTextProps={{
                sx: { color: validatedHash ? 'success.main' : 'text.secondary' },
              }}
            />
            {householdError && (
              <Typography variant="body2" color="error" sx={{ mt: 0.5 }}>
                {householdError}
              </Typography>
            )}
          </Box>
        )}
      </SimpleForm>
    </Create>
  );
};

export default ParentCreate;
